import React, { Fragment } from "react";
import styled from "styled-components";
import _ from "lodash";
import { connect } from "react-redux";
import { compose } from "redux";
import queryString from "query-string";
import { Tabs, Tab, AppBar, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import SecondaryButton from "components/Global/Buttons/SecondaryButton";
import { downloadPrincipalAndInterestPaymentTemplate } from "store/state/cashflows";

const DownloadPrincipalAndInterestPaymentTemplate = props => (
  <SecondaryButton onClick={() => props.downloadPrincipalAndInterestPaymentTemplate({ loanId: props.loanId })}>P&amp;I Payment Template</SecondaryButton>
);

export default connect(null, {
  downloadPrincipalAndInterestPaymentTemplate
})
(DownloadPrincipalAndInterestPaymentTemplate);
